import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

const SYNC_ID = "admin-dashboard";

async function assertAdmin(supabase: any, userId: string) {
  const { data } = await supabase
    .from("user_roles")
    .select("role")
    .eq("user_id", userId)
    .eq("role", "admin")
    .maybeSingle();
  if (!data) throw new Error("Forbidden");
}

export const getAdminSyncState = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    await assertAdmin(context.supabase, context.userId);
    const { data } = await context.supabase
      .from("admin_sync_state")
      .select("synced_at")
      .eq("id", SYNC_ID)
      .maybeSingle();
    return { syncedAt: data?.synced_at ?? null };
  });

export const recordAdminSync = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    await assertAdmin(context.supabase, context.userId);
    const now = new Date().toISOString();
    const { error } = await context.supabase
      .from("admin_sync_state")
      .upsert(
        { id: SYNC_ID, synced_at: now, synced_by: context.userId, updated_at: now },
        { onConflict: "id" },
      );
    if (error) throw new Error(error.message);
    return { syncedAt: now };
  });
